<template>
  <section class="how">
    <h2 class="how__title content__title content__title--contrast">
      Zamów książkę!
    </h2>
    <div class="how__intro content__text">
      Nie znajdziesz jej w księgarni. Dostępna jest wyłącznie na tej stronie 🙂 Otrzyma ją każda osoba, która na stronie rewolucyjna.pl zdecyduje się na przekazanie darowizny na rzecz Greenpeace w opcji jednorazowej lub cyklicznej. Twoje wsparcie pozwala nam działać na rzecz ochrony klimatu i najcenniejszych ekosystemów na Ziemi, dlatego w podziękowaniu chcemy Ci przekazać tę świetną publikację!
    </div>
    <div class="how__boxes">
      <div class="how__box">
        <div class="how__box-title" v-html="content.data.how.content__2_0">
          
        </div>
        <div class="how__box-content">
      Jeśli zdecydujesz się na wspieranie Greenpeace, książkę wyślemy Ci zaraz po przekazaniu pierwszej darowizny. Maksymalny czas wysyłki to 30 dni od dnia zamówienia! Zwykle udaje się dużo szybciej!
        </div>
      </div>
      <div class="how__box">
        <div class="how__box-title" v-html="content.data.how.content__3_0">
     
        </div>
        <div class="how__box-content">
          Tak! Jeśli wybierzesz wsparcie regularne  w wysokości minimum 30 zł miesięcznie, otrzymasz od nas wyjątkowy również plakat autorstwa Marty Frej lub Patryka Hardzieja – Ty wybierasz który!
        </div>
      </div>
    </div>
    <div class="how__form" id="how__form">
         <InvitationMobile /> 
    </div>
  </section>
</template>

<script>
import InvitationMobile from "@/components/InvitationMobile.vue";
export default {
  name: "HowToGetBook",
    components: {
    InvitationMobile,
  },
    inject: ['content'],
};
</script>
